module.exports = {
          srcSet: __webpack_public_path__ + "ec2ba075fba0eb7571e0edf28df20983-460.png"+" 460w",
          images:[ {path: __webpack_public_path__ + "ec2ba075fba0eb7571e0edf28df20983-460.png",width: 460,height: 526}],
          src: __webpack_public_path__ + "ec2ba075fba0eb7571e0edf28df20983-460.png",
          toString:function(){return __webpack_public_path__ + "ec2ba075fba0eb7571e0edf28df20983-460.png"},
          
          width: 460,
          height: 526
        }